export default "__VITE_ASSET__73b9e177__"